<template>
  <div
    class="fixed inset-0 pointer-events-none overflow-hidden"
    :style="{ zIndex: zIndex }"
    aria-hidden="true"
  >
    <!-- We use a subtle gradient mask so it fades out toward the edges -->
    <div
      class="absolute inset-0 transition-opacity duration-1000"
      :class="isLightMode ? 'opacity-[0.15]' : 'opacity-[0.10]'"
      style="
        mask-image: radial-gradient(
          circle at center,
          black 0%,
          transparent 90%
        );
        -webkit-mask-image: radial-gradient(
          circle at center,
          black 0%,
          transparent 90%
        );
      "
    >
      <div
        class="compass-wrapper absolute w-[150vw] h-[150vw] sm:w-[120vw] sm:h-[120vw] left-1/2 top-1/2"
      >
        <svg viewBox="0 0 1000 1000" class="w-full h-full compass-svg">
          <g transform="translate(500, 500)">
            <!-- Outer rings -->
            <circle
              cx="0"
              cy="0"
              r="480"
              fill="none"
              stroke="currentColor"
              stroke-width="1"
            />
            <circle
              cx="0"
              cy="0"
              r="460"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
            />
            <circle
              cx="0"
              cy="0"
              r="400"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-dasharray="4 8"
            />
            <circle
              cx="0"
              cy="0"
              r="300"
              fill="none"
              stroke="currentColor"
              stroke-width="0.5"
            />
            <circle
              cx="0"
              cy="0"
              r="280"
              fill="none"
              stroke="currentColor"
              stroke-width="1"
              stroke-dasharray="2 12"
            />

            <!-- Degree Ticks -->
            <g v-for="i in 72" :key="i" :transform="`rotate(${i * 5})`">
              <!-- Major/Minor ticks -->
              <line
                :x1="i % 18 === 0 ? 430 : i % 2 === 0 ? 440 : 450"
                y1="0"
                x2="460"
                y2="0"
                stroke="currentColor"
                :stroke-width="i % 18 === 0 ? 3 : 1"
              />
              <text
                v-if="i % 6 === 0"
                x="410"
                y="0"
                fill="currentColor"
                font-size="14"
                font-weight="bold"
                font-family="monospace"
                text-anchor="middle"
                alignment-baseline="middle"
                transform="rotate(90 410 0)"
              >
                {{ i * 5 }}&deg;
              </text>
            </g>

            <!-- Inner Compass Star/Rose -->
            <path
              d="M0 -250 L15 -50 L250 0 L15 50 L0 250 L-15 50 L-250 0 L-15 -50 Z"
              fill="none"
              stroke="currentColor"
              stroke-width="1"
            />
            <!-- Shaded facets -->
            <path
              d="M0 -250 L15 -50 L0 0 Z"
              fill="currentColor"
              opacity="0.3"
            />
            <path d="M250 0 L15 50 L0 0 Z" fill="currentColor" opacity="0.3" />
            <path d="M0 250 L-15 50 L0 0 Z" fill="currentColor" opacity="0.3" />
            <path
              d="M-250 0 L-15 -50 L0 0 Z"
              fill="currentColor"
              opacity="0.3"
            />

            <!-- Center point -->
            <circle
              cx="0"
              cy="0"
              r="10"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            />
            <circle cx="0" cy="0" r="3" fill="currentColor" />

            <!-- Secondary Star -->
            <path
              d="M0 -120 L10 -30 L120 0 L10 30 L0 120 L-10 30 L-120 0 L-10 -30 Z"
              fill="none"
              stroke="currentColor"
              stroke-width="0.5"
            />
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompassBackground",
  props: {
    isLightMode: {
      type: Boolean,
      default: true,
    },
    zIndex: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped>
.compass-wrapper {
  /* Center it, apply 3D perspective to tilt and skew it slightly */
  transform: translate(-50%, -50%) perspective(1200px) rotateX(55deg)
    rotateY(-15deg) rotateZ(10deg);
}

.compass-svg {
  /* Slow continuous rotation to add life to the background */
  animation: rotate-compass 240s linear infinite;
}

@keyframes rotate-compass {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
